import { Component, ElementRef, ViewChild, Input, OnChanges, SimpleChanges, Output, EventEmitter }  from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
  

@Component({
  selector: 'link-text-area',
  template: require('./link-text-area.component.html'),
  styles: [require('./link-text-area.component.css')]
})
export class LinkTextAreaComponent implements OnChanges {
  @ViewChild('editableContent') editableContentRef: ElementRef;
  @ViewChild('labelForEditableContent') labelForEditableContent: ElementRef;
  @Input() value: any;
  @Input() labelText: string = "";
  @Output() changedTextEvent = new EventEmitter<string>();
  
  formattedText: SafeHtml;
  private savedSelection: Range | null = null;
  backspace: boolean = false;
  startOffSet: number = 0;
  contentEditable: boolean = true;
  regex = /(https?|ftp):\/\/[^\s]+|www\.[^\s]+/gi;

  constructor(private sanitizer: DomSanitizer) {
    this.formattedText = '';
  }

  ngAfterViewInit() {
    this.editableContentRef.nativeElement.addEventListener('paste', this.onPaste.bind(this));
    this.editableContentRef.nativeElement.addEventListener('cut', this.onCut.bind(this));
    this.editableContentRef.nativeElement.addEventListener('focus', this.onFocus.bind(this));
    this.editableContentRef.nativeElement.addEventListener('blur', this.onBlur.bind(this));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value){
      if (changes.value.currentValue === "")
        return;

      const enteredText = changes.value.currentValue || "";
      const sanitizedText = enteredText.replace(this.regex, match => '<a href=' + match + ' target="_blank" style="cursor: pointer;text-decoration: underline; color:#0b4c8c">' + match + '</a>');
      this.formattedText = this.sanitizer.bypassSecurityTrustHtml(sanitizedText);
      if (!(enteredText=="" || enteredText=='\n')){
         this.editableContentRef.nativeElement.nextElementSibling.classList.add('active');
      }
    }
  }

  onPaste(event: ClipboardEvent){
     this.saveSelection();
     const clipboardData = event.clipboardData || (window as any).clipboardData;
     const pastedText = clipboardData.getData('text');
     this.startOffSet+=pastedText.length;
  }

  onCut(event: ClipboardEvent){
    this.saveSelection();
  }

  onFocus(event){
    this.editableContentRef.nativeElement.nextElementSibling.classList.add('active');
    this.editableContentRef.nativeElement.nextElementSibling.classList.add('link-text-area-label');
    this.editableContentRef.nativeElement.parentElement.classList.add('link-text-area-selected');
  }

  onBlur(event){
    if (this.editableContentRef.nativeElement.contentEditable == 'false')
      return;

    if (this.editableContentRef.nativeElement.innerText.length==0
       || this.editableContentRef.nativeElement.innerText== '\n'
      ){
      this.editableContentRef.nativeElement.nextElementSibling.classList.remove('active');
    }
    this.editableContentRef.nativeElement.nextElementSibling.classList.remove('link-text-area-label');
    this.editableContentRef.nativeElement.parentElement.classList.remove('link-text-area-selected');
  }

  handleInput(event: Event) {
    
    const editableDiv = this.editableContentRef.nativeElement;
    if (!this.isMobileDevice())
      editableDiv.contentEditable = 'false';
    const enteredText = this.editableContentRef.nativeElement.innerText;
    const sanitizedText = enteredText.replace(this.regex, '<a href="$&" target="_blank" style="cursor: pointer;text-decoration: underline; color:#0b4c8c">$&</a>');
    this.formattedText = this.sanitizer.bypassSecurityTrustHtml(sanitizedText);
    this.changedText();
    this.transitionDelay(1).then(() => {
      this.restoreSelection();
    });
  }

  convertTextToLinkedText(originalText){
    const sanitizedText = originalText.replace(this.regex, '<a href="$&" target="_blank" style="cursor: pointer;text-decoration: underline; color:#0b4c8c">$&</a>');
    return sanitizedText;    
  }

  handleLinkClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.tagName === 'A') {
      event.preventDefault();
      const url = (target as HTMLAnchorElement).getAttribute('href');
      if (!(url.startsWith('http://') || url.startsWith('https://') || url.startsWith('ftp://')))
        window.open('//'+url, '_blank');
      else
        window.open(url, '_blank');

    }
  }

  handleKeyDown(event: KeyboardEvent) {
    this.backspace = event.key == 'Backspace';
      this.saveSelection();

      if (
          (event.key === 'v' || event.key === 'V') && (event.ctrlKey || event.metaKey) ||
          (event.key === 'x' || event.key === 'X') && (event.ctrlKey || event.metaKey)
          ){
        return;
      }
      
      if (event.key === 'Enter'){
        if (!this.isMobileDevice())
          this.editableContentRef.nativeElement.contentEditable = 'false';
        const position = this.getCursorOffsetRelativeToDiv();
        const enteredText = this.editableContentRef.nativeElement.innerText;
        const sanitizedText =  this.insertCarrierReturn(enteredText,position);
        this.formattedText = this.sanitizer.bypassSecurityTrustHtml(sanitizedText);
        this.startOffSet++;
        this.transitionDelay(1).then(() => {
          this.restoreSelection();
          this.handleInput(null);
        });
        return;
      }

      if (this.backspace)
      {
        this.startOffSet--;
      }
      else
      {
        this.startOffSet++;
      }
      if (event.key === 'Delete')
        this.startOffSet--;
  }

  private saveSelection() {
    const selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
      this.savedSelection = {...selection.getRangeAt(0)};
      this.startOffSet = selection.getRangeAt(0).startOffset;
    }

    if (selection.anchorNode && selection.anchorNode.nodeType === Node.TEXT_NODE) {
      this.startOffSet =  this.getCursorOffsetRelativeToDiv();
    }
  }

  private restoreSelection() {
    try{
      const editableDiv = this.editableContentRef.nativeElement;
      var positionAtNode = this.startOffSet;
      var cumulativeLenghts = 0;
      var currentNode;
      const childNodesArray = Array.from(editableDiv.childNodes); 
      
      childNodesArray.every(n => {
        var node = n as Text | Element;
        cumulativeLenghts+=node.textContent.length;
        if (this.startOffSet > cumulativeLenghts){
          positionAtNode = this.startOffSet - cumulativeLenghts;
          return true;
        }
        else{
          return false;
        }
      });
      cumulativeLenghts=0;
      childNodesArray.every(n => {
        var node = n as Text | Element;
        cumulativeLenghts+=node.textContent.length;
        if (this.startOffSet <= cumulativeLenghts){
          currentNode = node;
          return false;
        }
          
        return true;
      });

      editableDiv.contentEditable = 'true';
      editableDiv.focus();
      const lastTextNode = currentNode;
      const range = document.createRange();
      if (lastTextNode && lastTextNode.textContent)
      {
        if (lastTextNode.nodeName == 'A')
        {
          range.setStart(lastTextNode.childNodes[0],positionAtNode);
          range.setEnd(lastTextNode.childNodes[0], positionAtNode);
        }
        else{
          range.setStart(lastTextNode, positionAtNode);
          range.setEnd(lastTextNode, positionAtNode);
        }
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
     
    }
    catch (e){
      console.log(e);
    }
  }

  transitionDelay(time) {
    return new Promise(resolve => setTimeout(resolve, time));
  }
  
 
  getCursorOffsetRelativeToDiv() {
    const editableDiv = this.editableContentRef.nativeElement;
  
    const selection = window.getSelection();
    const range = selection.getRangeAt(0);
  
    const cursorRange = document.createRange();
    cursorRange.selectNodeContents(editableDiv);
    cursorRange.setEnd(range.startContainer, range.startOffset);
  
    const cursorOffset = cursorRange.toString().length;
  
    cursorRange.detach();
    range.detach();
  
    return cursorOffset;
  }

  insertCarrierReturn(originalString, position) {
    var character = '\n';
    if (position < 0 || position > originalString.length) {
      throw new Error("Invalid position");
    }
    
    if (position == originalString.length)
      character+='\n';

    const part1 = originalString.substring(0, position);
    const part2 = originalString.substring(position);
    const modifiedString = part1 + character + part2;
    
    return modifiedString;
  }

  setCursor(){
   this.editableContentRef.nativeElement.focus();
  }

  handleTextAreaClick(event){
    this.onFocus(null);    
  }

  changedText() {
    this.changedTextEvent.emit(this.editableContentRef.nativeElement.innerText);
  }

  isMobileDevice(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/helper-components/link-text-area.component.ts